export default __webpack_public_path__ + "static/media/CrabPage2.e9054435.txt";